























import BaseComponent from "@/components/BaseComponent.vue";
import { Component, Prop, Emit } from "vue-property-decorator";

const getForm = function() {
	return {
		fields: {
			min: {
				field: "input",
				label: { i18n: "SX_LANG_CHARS_MIN_LENGTH" },
				attrs: {
					type: "number",
					min: 0,
					name: "min",
					autocomplete: "off"
				}
			},
			max: {
				field: "input",
				label: { i18n: "SX_LANG_CHARS_MAX_LENGTH" },
				attrs: {
					type: "number",
					min: 0,
					name: "max",
					autocomplete: "off"
				}
			}
		}
	};
};

@Component
export default class WQtypeBigtext extends BaseComponent {
	@Prop({ type: Object, required: true })
	options!: any;

	answerValue = null;

	get form() {
		return getForm();
	}

	@Emit("type-state-change")
	onOptionsChange() {
		let min = this.options.min,
			max = this.options.max,
			state = min >= 0 && (max ? min <= max : true);

		return state;
	}

	mounted() {
		this.onOptionsChange();
	}
}
